import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {FilterUtil} from "../../../util/filter.util";
import {ListResponse} from "../../../network/service/list.response";
import {SnackBarUtil} from "../../../util/snack.bar.util";
import {VerifyOptions} from "../../dialog/verify/options/verify.options";
import {VerifyComponent} from "../../dialog/verify/verify.component";
import {DataResponse} from "../../../network/service/data.response";
import {AddOrUpdateRoleOptions} from "../dialog/add-or-update-role/options/add-or-update-role.options";
import {AddOrUpdateRoleComponent} from "../dialog/add-or-update-role/add-or-update-role.component";
import {Params} from "@angular/router";
import {RouteUtil} from "../../../util/route.util";

@Component({
  selector: 'app-roles',
  standalone: false,
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent extends BaseComponent implements OnInit {
  displayedColumns = ['Update', 'Delete', 'InsertRolePermission', 'Title'];
  displayDataSources = ['edit', 'delete', 'touch_app', 'Title'];
  displayColumnTypes = ['event', 'event', 'event', 'string'];
  displayEndPoint = [this.ServicePath.UPDATE_ROLES, this.ServicePath.DELETE_ROLES, this.ServicePath.CREATE_ROLES_PERMISSIONS, ''];
  roles: any = [];
  businessId?: any;
  businessTitle?: string;
  allFilters = FilterUtil.RolesFilters;
  filters: any = {};

  constructor(injector: Injector) {
    super(injector);
    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['BusinessId'] && params['BusinessId'] !== '') {
        this.businessId = params['BusinessId'];
      }
      if (params['BusinessTitle'] && params['BusinessTitle'] !== '') {
        this.businessTitle = params['BusinessTitle'];
      }
    });
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getRoles(this.tableProperties.offset, this.tableProperties.limit, undefined, undefined, {
      Filter: this.filters,
      Order: this.tableProperties.order ?? {
        Field: 'ModifyDate',
        Type: 'DESC'
      }
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.roles = res.data;
        this.tableProperties.pageLength = res.count;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override setListeners() {
    super.setListeners();
    if (this.roles) {
      for (let i = 0; i < this.roles.length; i++) {
        this.roles[i].edit = (index: number) => {
          this.onUpdateClicked(index);
        };
        this.roles[i].delete = (index: number) => {
          this.onDeleteClicked(index);
        };
        this.roles[i].touch_app = (index: number) => {
          this.onUpdateRolePermissionClicked(index);
        };
      }
    }
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.loadOnline();
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.loadOnline();
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.tableProperties.offset = 0;
    this.loadOnline();
  }

  onCreateClicked() {
    let addOrUpdateRoleOptions = new AddOrUpdateRoleOptions();
    addOrUpdateRoleOptions.role = {};
    addOrUpdateRoleOptions.businessId = this.businessId;
    addOrUpdateRoleOptions.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateRoleComponent = this.matDialog.open(AddOrUpdateRoleComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateRoleComponent.componentInstance.addOrUpdateRoleOptions = addOrUpdateRoleOptions;
  }

  onUpdateClicked(index: number) {
    let addOrUpdateRoleOptions = new AddOrUpdateRoleOptions();
    addOrUpdateRoleOptions.role = this.roles[index];
    addOrUpdateRoleOptions.businessId = this.businessId;
    addOrUpdateRoleOptions.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateRoleComponent = this.matDialog.open(AddOrUpdateRoleComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateRoleComponent.componentInstance.addOrUpdateRoleOptions = addOrUpdateRoleOptions;
  }

  onDeleteClicked(index: number) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف درخواست خود مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deleteRoles(this.roles[index].RoleId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadOnline();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }

  onUpdateRolePermissionClicked(index: number) {
    this.router.navigate([RouteUtil.DASHBOARD_MODULE, RouteUtil.ROLE_PERMISSIONS_COMPONENT, {
      BusinessId: this.businessId,
      RoleId: this.roles[index].RoleId,
      RoleTitle: this.roles[index].Title
    }]).then();
  }
}
